import {
  matchCountryCode,
  matchStringToNumber,
  matchValidateNumberWord,
  matchValidateStringWord,
} from "./../utils/Parses";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Mrz } from "../passapp-sdk/models/Mrz";
import { updateTimer } from "../redux/actions/scanTesseractMrzActions";
import { controlDni } from "../utils/Parses";
import { recognize as recognizeScan } from "../utils/Tesseract";
import Webcam from "react-webcam";
var ImageFilter = require("image-filters");

const useScanMRZ = (video?: React.RefObject<Webcam> | null) => {
  const dispatch = useDispatch();
  const [data, setData] = useState<Mrz | null>(null);
  const [isMrz, setIsMrz] = useState(false);
  let object: Mrz = {
    country: "",
    dni: "",
    sex: "",
    firstname: "",
    lastname: "",
    mrz: [],
  };

  const recognize = async () => {
    if (video?.current) {
      const canva: HTMLCanvasElement = document.createElement("canvas");
      const width = video.current.video?.videoWidth || 640;
      const height = video.current.video?.videoHeight || 480;
      const context = canva.getContext("2d");
      const cropTop = width > height ? 30 : 40; //optimized to verticals camera
      const cropCenter = width > height ? 30 : 20; //optimized to verticals camera
      const heightTop = (height * cropTop) / 100;
      const heightCenter = (height * cropCenter) / 100;
      if (context && video.current.video) {
        canva.width = width;
        canva.height = heightCenter;
        context.drawImage(
          video.current.video,
          0,
          heightTop,
          width,
          heightCenter,
          0,
          0,
          width,
          heightCenter
        );
        if (canva) {
          recognizeResult(canva, context.getImageData(0, 0, width, heightCenter));
        }
      }
    }
  };

  const recognizeResult = (canva: HTMLCanvasElement, imageData: any) => {
    recognizeScan(canva)
      .then((value) => {
        const data = filterData(value, 1);
        if (data) {
          setData(data);
        } else {
          /*let filtered = new ImageFilter({
            imageData,
          });
          filtered.threshold({ threshold: 90 });
          filtered.apply().then((result: any) => {
            const canvaImage = imageDataToCanva(result);
            recognizeScan(canvaImage).then((value) => {
              console.log('value2: ' + value);
              const data = filterData(value, 2);
              if (data) setData(data);
            });
          });*/
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        dispatch(updateTimer());
      });
  };

  const filterData = (value: string, attempt: any) => {
    let data = null;
    const spliter = value.split(/\s+/);
    const filter = spliter.filter((obj) => obj.includes("<") && obj.length > 5);
    if (filter.length === 3) {
      data = parse(filter);
      setIsMrz(true);
    } else setIsMrz(false);
    return data;
  };

  const imageDataToCanva = (imageData: any) => {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    canvas.width = imageData.width;
    canvas.height = imageData.height;
    if (ctx) ctx.putImageData(imageData, 0, 0);
    return canvas;
  };

  const parse = (lines: string[]) => {
    const MATCH_ID = "ID";
    const MATCH_I = "I<";
    let isValidated = false;
    lines.forEach((item, index) => {
      item = item.replaceAll(" ", "");
      switch (index) {
        case 0: {
          if (item.includes(MATCH_ID) || item.includes(MATCH_I)) {
            let i;
            if (item.includes(MATCH_ID)) i = item.indexOf(MATCH_ID);
            if (item.includes(MATCH_I)) i = item.indexOf(MATCH_I);
            if (i === 0) {
              const country = matchCountryCode(matchValidateStringWord(item.substr(2, 3)));
              if (country.match(/[a-zA-Z]/)) {
                object = {
                  ...object,
                  country,
                };
                const dni = matchValidateNumberWord(item.substr(5, 8));
                if (dni.match(/[0-9]/)) {
                  const codeValidator = matchStringToNumber(item.substr(14, 1));
                  if (codeValidator.match(/[0-9]/)) {
                    if (controlDni(dni, codeValidator)) {
                      object = {
                        ...object,
                        dni,
                      };
                      isValidated = true;
                    }
                  }
                }
              }
            }
          }
          break;
        }
        case 2: {
          const splitter = item.split("<");
          object = {
            ...object,
            lastname: matchValidateStringWord(splitter[0]),
          };
          splitter.forEach((item, indexS) => {
            if (indexS > 0) {
              object = {
                ...object,
                firstname: object.firstname + " " + matchValidateStringWord(item.trim()),
              };
            }
          });
          object.firstname = object.firstname.trim();
        }
      }
    });
    if (isValidated) return object;
    else return null;
  };

  return { data, isMrz, recognize };
};

export default useScanMRZ;
